import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  onSnapshot,
  query,
  orderBy,
  limit,
} from "firebase/firestore";
import "../css/SchoolPoll.css";

const SchoolPoll = ({ isPopup, onClose }) => {
  const [step, setStep] = useState(1);
  const [selectedSchools, setSelectedSchools] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [liveStats, setLiveStats] = useState([]);
  const [loading, setLoading] = useState(false);

  const schoolList = [
    "AL-Helal Public Secondary School ,Krishna Nagar",
    "Devi Vidya Pith Mavi,  Shiva nagar ",
    "Gorakhnath Academy, Babahadurganj",
    "Janata Mavi, karma",
    "Janata Mavi, Prushuttampur",
    "Lumbini Galaxy English Boarding School, Bahadurganj",
    "Netra Jyoti Mavi, Saunahawa",
    "Rastriya Mavi, Hirday nagar",
    "Sahara Public Secondary School,Krishna Nagar",
    "Shri Mahendra Mavi ,Krishna Nagar",
    "Shri Mavi, Agigara",
    "Shri Ram Gorkha Mavi,Bahadurganj",
    "St. Judes English Boarding School, Bahadurganj",
    "St. Judes english Boarding School, Krishna Nagar",
    "Zalmonah Little Angels English Secondary Boarding School , Krishna Nagar",
  ];

  useEffect(() => {
    const q = query(collection(db, "votes"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const votes = snapshot.docs.map((doc) => doc.data());
      calculateLeaderboard(votes);
    });
    return () => unsubscribe();
  }, []);

  const calculateLeaderboard = (allVotes) => {
    const counts = {};

    schoolList.forEach((school) => (counts[school] = 0));

    allVotes.forEach((v) => {
      if (v.first) counts[v.first] = (counts[v.first] || 0) + 3;
      if (v.second) counts[v.second] = (counts[v.second] || 0) + 2;
      if (v.third) counts[v.third] = (counts[v.third] || 0) + 1;
    });

    const sorted = Object.keys(counts)
      .map((name) => ({
        name,
        points: counts[name],

        color: counts[name] > 0 ? "#1a4571" : "#ccc",
      }))
      .sort((a, b) => b.points - a.points);

    setLiveStats(sorted);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await addDoc(collection(db, "votes"), {
        ...selectedSchools,
        rating,
        comment,
        timestamp: new Date(),
      });
      alert("Success! Your vote has been recorded.");
      if (isPopup) onClose();
      else setStep(1);
    } catch (err) {
      alert("Error submitting vote: " + err.message);
    }
    setLoading(false);
  };

  const getFilteredList = (currentRank) => {
    const selectedValues = Object.entries(selectedSchools)
      .filter(([rank, name]) => rank !== currentRank && name !== "")
      .map(([rank, name]) => name);
    return schoolList.filter((school) => !selectedValues.includes(school));
  };

  return (
    <div className={isPopup ? "poll-modal-overlay" : "poll-page-wrapper"}>
      <div className={`poll-container ${!isPopup ? "page-layout" : ""}`}>
        <div className="poll-card">
          {isPopup && (
            <button className="close-poll" onClick={onClose}>
              &times;
            </button>
          )}
          <h2>🏆 {isPopup ? "Quick Vote" : "Top 3 School Selection"}</h2>

          {step === 1 ? (
            <div className="poll-step">
              <div className="rank-input">
                <label>🥇 1st Choice</label>
                <select
                  value={selectedSchools.first}
                  onChange={(e) =>
                    setSelectedSchools({
                      ...selectedSchools,
                      first: e.target.value,
                    })
                  }
                >
                  <option value="">Select #1 School</option>
                  {getFilteredList("first").map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              <div className="rank-input">
                <label>🥈 2nd Choice</label>
                <select
                  value={selectedSchools.second}
                  onChange={(e) =>
                    setSelectedSchools({
                      ...selectedSchools,
                      second: e.target.value,
                    })
                  }
                >
                  <option value="">Select #2 School</option>
                  {getFilteredList("second").map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              <div className="rank-input">
                <label>🥉 3rd Choice</label>
                <select
                  value={selectedSchools.third}
                  onChange={(e) =>
                    setSelectedSchools({
                      ...selectedSchools,
                      third: e.target.value,
                    })
                  }
                >
                  <option value="">Select #3 School</option>
                  {getFilteredList("third").map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>

              <button
                className="next-btn"
                onClick={() => setStep(2)}
                disabled={
                  !selectedSchools.first ||
                  !selectedSchools.second ||
                  !selectedSchools.third
                }
              >
                Next Step
              </button>
            </div>
          ) : (
            <div className="poll-step">
              <div className="rating-input">
                <label>Rate {selectedSchools.first} (1-10)</label>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={rating}
                  onChange={(e) => setRating(e.target.value)}
                />
                <span className="rating-display">{rating}/10</span>
              </div>
              <textarea
                placeholder="Tell us why these are your top choices..."
                className="poll-area"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
              <div className="poll-btns">
                <button onClick={() => setStep(1)} className="back-btn">
                  Back
                </button>
                <button
                  onClick={handleSubmit}
                  className="submit-poll-btn"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Submit Rankings"}
                </button>
              </div>
            </div>
          )}
        </div>

        {!isPopup && (
          <div className="poll-stats-sidebar full-leaderboard">
            <h3>Live Leaderboard 2026</h3>
            <p>Real-time rankings of all local schools</p>

            <div className="stats-list-scrollable">
              {liveStats.length > 0 ? (
                liveStats.map((school, index) => (
                  <div key={index} className="stat-item">
                    <div className="stat-info">
                      <span className="rank-number">#{index + 1}</span>
                      <span className="school-name">{school.name}</span>
                    </div>
                    <div className="progress-bar-bg">
                      <div
                        className="progress-bar-fill"
                        style={{
                          width: `${school.points > 0 ? (school.points / (liveStats[0].points || 1)) * 100 : 0}%`,
                          backgroundColor: school.color,
                        }}
                      ></div>
                    </div>
                    <div className="stat-meta">
                      <span>🔥 {school.points} Points</span>
                    </div>
                  </div>
                ))
              ) : (
                <p>Loading rankings...</p>
              )}
            </div>

            <div className="poll-info-box">
              <h4>Voting Rules</h4>
              <p>1st Rank: 3 Pts | 2nd Rank: 2 Pts | 3rd Rank: 1 Pt</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SchoolPoll;
